import { FC } from "react";

import { Spinner } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import TextInput from "@components/TextInput";
import { useZipCodeUpdate } from "@lib/street-autocomplete";
import { ORDER_FIELDS_MAX_LENGTHS } from "@modules/order/constants";

type TZipCodeInputProps = {
  id: string;
  name: string;
  streetFieldName: string;
  houseNoFieldName: string;
  cityFieldName: string;
  countryCode: string;
  isAddressSelectedFromAddressBook: boolean;
  isUpdateFromZipCode: boolean;
};

const ZipCodeInput: FC<TZipCodeInputProps> = ({
  id,
  name,
  streetFieldName,
  houseNoFieldName,
  cityFieldName,
  countryCode,
  isAddressSelectedFromAddressBook,
  isUpdateFromZipCode
}) => {
  const { t } = useTranslation();

  const { isZipCodeLoading, isZipError } = useZipCodeUpdate({
    zipCodeFieldKey: name,
    streetFieldKey: streetFieldName,
    cityFieldKey: cityFieldName,
    houseNoFieldKey: houseNoFieldName,
    country: countryCode,
    isAddressSelectedFromAddressBook,
    isUpdateFromZipCode
  });

  return (
    <TextInput
      name={name}
      label={t("address_fields-zip_code")}
      id={id}
      rightAddon={isZipCodeLoading ? <Spinner mt="0.375rem" size="md" /> : null}
      rightAddonOffset={isZipError ? "2.5rem" : "1rem"}
      maxLength={ORDER_FIELDS_MAX_LENGTHS.zip}
    />
  );
};
export default ZipCodeInput;
